/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCharactersCharacterIdPlanetsPlanetIdHead } from './GetCharactersCharacterIdPlanetsPlanetIdHead';
import {
    GetCharactersCharacterIdPlanetsPlanetIdHeadFromJSON,
    GetCharactersCharacterIdPlanetsPlanetIdHeadFromJSONTyped,
    GetCharactersCharacterIdPlanetsPlanetIdHeadToJSON,
    GetCharactersCharacterIdPlanetsPlanetIdHeadToJSONTyped,
} from './GetCharactersCharacterIdPlanetsPlanetIdHead';

/**
 * extractor_details object
 * @export
 * @interface GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails
 */
export interface GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails {
    /**
     * in seconds
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails
     */
    cycleTime?: number;
    /**
     * head_radius number
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails
     */
    headRadius?: number;
    /**
     * heads array
     * @type {Array<GetCharactersCharacterIdPlanetsPlanetIdHead>}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails
     */
    heads: Array<GetCharactersCharacterIdPlanetsPlanetIdHead>;
    /**
     * product_type_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails
     */
    productTypeId?: number;
    /**
     * qty_per_cycle integer
     * @type {number}
     * @memberof GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails
     */
    qtyPerCycle?: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails interface.
 */
export function instanceOfGetCharactersCharacterIdPlanetsPlanetIdExtractorDetails(value: object): value is GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails {
    if (!('heads' in value) || value['heads'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsFromJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails {
    return GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'cycleTime': json['cycle_time'] == null ? undefined : json['cycle_time'],
        'headRadius': json['head_radius'] == null ? undefined : json['head_radius'],
        'heads': ((json['heads'] as Array<any>).map(GetCharactersCharacterIdPlanetsPlanetIdHeadFromJSON)),
        'productTypeId': json['product_type_id'] == null ? undefined : json['product_type_id'],
        'qtyPerCycle': json['qty_per_cycle'] == null ? undefined : json['qty_per_cycle'],
    };
}

export function GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsToJSON(json: any): GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails {
    return GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsToJSONTyped(json, false);
}

export function GetCharactersCharacterIdPlanetsPlanetIdExtractorDetailsToJSONTyped(value?: GetCharactersCharacterIdPlanetsPlanetIdExtractorDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cycle_time': value['cycleTime'],
        'head_radius': value['headRadius'],
        'heads': ((value['heads'] as Array<any>).map(GetCharactersCharacterIdPlanetsPlanetIdHeadToJSON)),
        'product_type_id': value['productTypeId'],
        'qty_per_cycle': value['qtyPerCycle'],
    };
}

